import React, { useEffect, useState, useRef } from "react";
import useProductStore from "../../../Stores/useProductStore";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import styles from "./SpecificProduct.module.css";

import { Link } from "react-router-dom";
import NewPolaroid from "../NewPolaroid";
import { useLocation } from "react-router-dom";

import ImageList from "./ImageList";
import MainImage from "./MainImage";
import ProductOverview from "./ProductOverview";
import ProductDetailsSection from "./ProductDetailsSection";
import PerfectWith from "./PerfectWith";
import ImageDots from "./ImageDots";
import { useSwipeable } from "react-swipeable";
import useCategoryStore from "../../../Stores/useCategoryStore";
function SpecificProduct() {
  const { product, loading } = useProductStore();
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  const { selectedCategory, setSelectedCategory, categories, getCategories } = useCategoryStore();
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const location = useLocation();
  const isWholesaleRoute = location.pathname.startsWith("/Wholesale/Products");
  const breadcrumbRoute = isWholesaleRoute ? "Wholesale/Products" : "Products";
  const breadcrumbLabel = isWholesaleRoute ? "Wholesale Products" : "Products";
  useEffect(() => {
    setSelectedImageIndex(0);
  }, [location]);

  const nextItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === product.Images.length - 1
        ? 0
        : selectedImageIndex + 1
    );
  };

  const previousItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === 0
        ? product.Images.length - 1
        : selectedImageIndex - 1
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextItem,
    onSwipedRight: previousItem,
  });


  const catName = product && product.FriendlyName && product.FriendlyName.includes('/') ? product.FriendlyName.split('/')[0] : '';


  useEffect(() => {
    const getCategoryData = async () => {
      await getCategories();
    };
    if (categories.length === 0) {
      getCategoryData();
    }
  },[location]);


  useEffect(() => {
    if (catName) {
      const category = categories.find(
        (cat) => cat.FriendlyName === catName
      );
      setSelectedCategory(category);
    }
    
  }, [catName, product, categories, setSelectedCategory ]);

  return (
    <div className={styles.SpecificProduct}>
      {loading ? (
        <p>Loading...</p>
      ) : product ? (
        <div>
          <BreadCrumb
            Route={breadcrumbRoute}
            RouteLabel={breadcrumbLabel}
            CategoryName={selectedCategory ? selectedCategory.Value : ''}
            CategoryLink={selectedCategory ? selectedCategory.FriendlyName : ''}
            ProductName={product.Name}
          />

          <div className={styles.ProductHeader}>
            <div className={styles.ProductNameMobile}>{product.Name}</div>

            <ImageList
              images={product.Images}
              onImageClick={handleImageClick}
            />
            <div {...handlers} className={styles.SwipeableContainer}>
              <div className={styles.ImageNavigation}>
                <div className={styles.prev} onClick={previousItem}>
                  &#10094;
                </div>
                <div className={styles.next} onClick={nextItem}>
                  &#10095;
                </div>
              </div>
              <MainImage
                images={product.Images}
                selectedImageIndex={selectedImageIndex}
              />
            </div>
            <ImageDots
              images={product.Images}
              selectedImageIndex={handleImageClick}
            />
            <ProductOverview product={product} />
          </div>
          <ProductDetailsSection product={product} />
          <PerfectWith product={product} />
        </div>
      ) : (
        <p>Product not found.</p>
      )}
    </div>
  );
}

export default SpecificProduct;
